// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".navbar-nav a[data-v-63a1d6ba] {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-left: 1px solid #eaeaea;\n}\n.navbar-nav i[data-v-63a1d6ba] {\n  font-size: 14px;\n  margin-right: 6px;\n  color: #204d74;\n}\n.icon-image[data-v-63a1d6ba] {\n  height: 20px;\n  width: 20px;\n  margin-right: 3px;\n}\n[data-v-63a1d6ba] .el-dialog {\n  max-width: 1000px;\n  z-index: 1000000000000;\n}", ""]);
// Exports
module.exports = exports;
